var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5576 0C18.0214 0.000151461 18.4002 0.378965 18.4004 0.842773V5.98633C18.4002 6.45007 18.0214 6.82895 17.5576 6.8291H12.4141C11.9504 6.82887 11.5715 6.45003 11.5713 5.98633C11.5713 5.52244 11.9502 5.14281 12.4141 5.14258H15.5244C14.1876 3.06276 11.8564 1.68555 9.2002 1.68555C5.05172 1.68555 1.68555 5.05172 1.68555 9.2002C1.68555 13.3487 5.05172 16.7148 9.2002 16.7148C11.8454 16.7148 14.1738 15.3451 15.5127 13.2783L15.5137 13.2764C15.6795 13.0252 15.9567 12.8575 16.2715 12.8574C16.9011 12.8574 17.3524 13.5273 16.9912 14.0967L16.9902 14.0957C15.3601 16.6825 12.4819 18.4004 9.2002 18.4004C4.11965 18.4004 0 14.2807 0 9.2002C0 4.11965 4.11965 0 9.2002 0C12.3053 0 15.0489 1.53835 16.7148 3.89453V0.842773C16.715 0.378872 17.0937 0 17.5576 0Z",
    fill: "#7898FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReupload);
export default __webpack_public_path__ + "static/media/Reupload.70c9754c7f636b00d3e5787c8c5c45db.svg";
export { ForwardRef as ReactComponent };